import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const UpdateConfigParamPage = lazyLoad(
  () => import('./Prefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
